import { z } from "zod";

export const brandsSchema = z.string().array();
export type BrandsType = z.infer<typeof brandsSchema>;
